// =================================================================
// Persistence: Settings repository (localStorage) (TODO Task 1.15)
// Graceful fallback if localStorage unavailable.
// =================================================================
import type { AppSettings } from '@/types';

const SETTINGS_KEY = 'amino-pk.settings';
const DISCLAIMER_KEY = 'amino-pk.disclaimer';

function safeLocalStorage(): Storage | null {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage;
    }
  } catch {
    // private browsing / disabled
  }
  return null;
}

export const settingsRepo = {
  load(): AppSettings | null {
    const ls = safeLocalStorage();
    if (!ls) return null;
    try {
      const raw = ls.getItem(SETTINGS_KEY);
      return raw ? (JSON.parse(raw) as AppSettings) : null;
    } catch {
      return null;
    }
  },
  save(settings: AppSettings): void {
    const ls = safeLocalStorage();
    if (!ls) return;
    try {
      ls.setItem(SETTINGS_KEY, JSON.stringify(settings));
    } catch {
      // quota / unavailable — ignore
    }
  },
};

export const disclaimerRepo = {
  load(): { acknowledged: boolean; dateISO: string } | null {
    const ls = safeLocalStorage();
    if (!ls) return null;
    try {
      const raw = ls.getItem(DISCLAIMER_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },
  save(ack: { acknowledged: boolean; dateISO: string }): void {
    const ls = safeLocalStorage();
    if (!ls) return;
    try {
      ls.setItem(DISCLAIMER_KEY, JSON.stringify(ack));
    } catch {
      // ignore
    }
  },
};
